// =========================================================
// AUX DOUCEURS D'ALEXANDRE — CONFIGURATION GLOBALE
// =========================================================

// 1. GESTION DU MENU MOBILE (Valable pour toutes les pages)
const menuBtn = document.querySelector('#menuBtn');
const navLinks = document.querySelector('#navLinks');
const cartCount = document.querySelector('.cart span');
let count = 0;

if (menuBtn && navLinks) {
  menuBtn.addEventListener('click', () => {
    const isOpen = navLinks.classList.toggle('open');
    menuBtn.setAttribute('aria-expanded', String(isOpen));
    menuBtn.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu');
  });

  navLinks.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      navLinks.classList.remove('open');
      menuBtn.setAttribute('aria-expanded', 'false');
      menuBtn.setAttribute('aria-label', 'Ouvrir le menu');
    });
  });
}

// 2. GESTION DU PANIER D'ACHATS
document.querySelectorAll('.add-cart').forEach(button => {
  button.addEventListener('click', () => {
    count++;
    if (cartCount) cartCount.textContent = count;
    button.textContent = '✓';
    setTimeout(() => button.textContent = 'AJOUTER AU PANIER', 900);
  });
});

// 3. BARRE DE RECHERCHE RAPIDE
document.querySelector('#searchBtn')?.addEventListener('click', () => {
  const search = prompt('Que souhaitez-vous chercher ?');
  if (search) alert(`Recherche : ${search}`);
});

// 4. LECTURE DES VIDÉOS PREMIUM EN AUTOPLAY
document.querySelectorAll('video[autoplay]').forEach(video => {
  video.muted = true;
  video.playsInline = true;

  const playVideo = () => {
    const promise = video.play();
    if (promise) promise.catch(() => {});
  };

  if (video.readyState >= 2) {
    playVideo();
  } else {
    video.addEventListener('loadeddata', playVideo, { once: true });
  }
});


// =========================================================
// MOTEUR DE FILTRAGE COMBINÉ INTERACTIF (ENROBAGE + RECETTE)
// SÉCURISÉ POUR TOUTES LES PAGES DU PROJET
// =========================================================
document.addEventListener('DOMContentLoaded', () => {
  const filterGroups = document.querySelectorAll('.filter-group, .filter-group-secondary');
  const productCards = document.querySelectorAll('.product-item-card');

  // État initial de notre recherche croisée (Ligne 1 + Ligne 2)
  let currentFilters = {
    enrobage: 'all',
    recette: 'all'
  };

  // LA SÉCURITÉ : Le code ne s'exécute QUE si les filtres et les produits sont sur la page actuelle
  if (filterGroups.length > 0 && productCards.length > 0) {
    
    filterGroups.forEach(group => {
      // On cherche les boutons valides du groupe (.filter-btn pour l'enrobage, .tag-btn pour la recette)
      const buttons = group.querySelectorAll('.filter-btn, .tag-btn');
      const filterType = group.getAttribute('data-filter-type'); // Donne 'enrobage' ou 'recette'

      buttons.forEach(button => {
        button.addEventListener('click', () => {
          
          // A. Mise à jour de l'état visuel actif au sein du groupe cliqué
          buttons.forEach(btn => btn.classList.remove('active'));
          button.classList.add('active');

          // B. Sauvegarde du filtre sélectionné pour ce critère précis
          currentFilters[filterType] = button.getAttribute('data-filter');

          // C. Calcul du filtrage croisé (Logique ET) sur chaque chocolat
          productCards.forEach(card => {
            const cardEnrobage = card.getAttribute('data-enrobage');
            const cardRecette = card.getAttribute('data-recette');

            // Le produit valide-t-il le choix de la ligne 1 ?
            const matchEnrobage = (currentFilters.enrobage === 'all' || cardEnrobage === currentFilters.enrobage);
            
            // Le produit valide-t-il le choix de la ligne 2 ?
            const matchRecette = (currentFilters.recette === 'all' || cardRecette === currentFilters.recette);

            // Le chocolat s'affiche uniquement s'il remplit les deux critères en même temps
            if (matchEnrobage && matchRecette) {
              card.classList.remove('fade-out');
            } else {
              card.classList.add('fade-out');
            }
          });

        });
      });
    });
  }
}); 